import { atom } from 'nanostores';
import { ANALYTICS_EVENTS } from '@dunea/shared';
import { capture } from '~/lib/posthog';

export type AccountTab = 'profile' | 'preferences' | 'plans' | 'credits' | 'topup';

export const $showAccountSettings = atom<boolean>(false);
export const $accountSettingsTab = atom<AccountTab>('profile');

/**
 * `source` names the surface that sent the user here (a paywall entry like
 * `deploy`, or a UI location like `sidebar`).
 *
 * The plans/top-up view events fire HERE rather than in the tab components so
 * every route into the pricing surface is counted by construction: there are a
 * dozen call sites across the workbench, the sidebar, the domains pages and the
 * credit alert, and instrumenting them individually would drift the first time
 * someone adds a thirteenth.
 */
export function openAccountSettings(tab: AccountTab = 'profile', source = 'unknown') {
  $accountSettingsTab.set(tab);
  $showAccountSettings.set(true);

  if (tab === 'plans') {
    capture(ANALYTICS_EVENTS.PLANS_VIEWED, { source });
  } else if (tab === 'topup') {
    capture(ANALYTICS_EVENTS.TOPUP_VIEWED, { source });
  }
}

export function closeAccountSettings() {
  $showAccountSettings.set(false);
}
